/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CreateCryptoLinkRequest
 */
export interface CreateCryptoLinkRequest {
  /**
   * Произвольный JSON-payload, скрываемый в ссылке
   * @type {{ [key: string]: any; }}
   * @memberof CreateCryptoLinkRequest
   */
  payload: { [key: string]: any }
  /**
   * Срок жизни ссылки в секундах (60–2592000); по умолчанию 3600
   * @type {number}
   * @memberof CreateCryptoLinkRequest
   */
  ttlSeconds?: number | null
}

/**
 * Check if a given object implements the CreateCryptoLinkRequest interface.
 */
export function instanceOfCreateCryptoLinkRequest(
  value: object
): value is CreateCryptoLinkRequest {
  if (!('payload' in value) || value['payload'] === undefined) return false
  return true
}

export function CreateCryptoLinkRequestFromJSON(
  json: any
): CreateCryptoLinkRequest {
  return CreateCryptoLinkRequestFromJSONTyped(json, false)
}

export function CreateCryptoLinkRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateCryptoLinkRequest {
  if (json == null) {
    return json
  }
  return {
    payload: json['payload'],
    ttlSeconds: json['ttlSeconds'] == null ? undefined : json['ttlSeconds'],
  }
}

export function CreateCryptoLinkRequestToJSON(
  value?: CreateCryptoLinkRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    payload: value['payload'],
    ttlSeconds: value['ttlSeconds'],
  }
}
